// TODO
import { clientLogger } from './client'

const isServer = typeof window === 'undefined'

// eslint-disable-next-line @typescript-eslint/no-var-requires
export const logger = isServer ? require('./server').logger : clientLogger
